// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3RM_A","head":"Table_head__3QGny","col":"Table_col__3ye7P"};